export const modulationLocationContractsCachekeys = {
  one: (modulation_location_contract_id: number) => [
    'modulation_location_contract',
    modulation_location_contract_id
  ],
  all: (location_id: number) => ['modulation_location_contracts', location_id],
  create: () => ['create_modulation_location_contracts'],
  update: (modulation_location_contract_id: number) => [
    'update_modulation_location_contract',
    modulation_location_contract_id
  ],
  deleteOne: () => ['delete_modulation_location_contract']
}
